import { Button } from 'eezy-components'
import { getErrorMsg } from 'helpers/error'
import { observer } from 'mobx-react'
import { useSnackbar } from 'notistack'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RequestedReviewStore } from 'stores'
import { useInstance } from 'util/di'

const RequestedReviewButton = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const {
    submitRequests,
    submittingRequests,
    selectedRequests,
    requestsNoteReadyForReview,
  } = useInstance<RequestedReviewStore>('RequestedReviewStore')

  const cannnotSubmitRequests = useMemo(() => {
    return (
      submittingRequests ||
      selectedRequests.length === 0 ||
      requestsNoteReadyForReview
    )
  }, [submittingRequests, selectedRequests.length, requestsNoteReadyForReview])

  const handleSubmit = async () => {
    try {
      await submitRequests()
      enqueueSnackbar(t('request_changes.review_success'), {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar(t(getErrorMsg(error) || 'errors.requests.generic'), {
        variant: 'error',
      })
    }
  }

  return (
    <Button
      color="primary"
      onClick={handleSubmit}
      loading={submittingRequests}
      disabled={cannnotSubmitRequests}
    >
      {t('util.submit')}
    </Button>
  )
}

export default observer(RequestedReviewButton)
